var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "outros" },
    [
      _c(
        "v-row",
        { staticClass: "flex-column", attrs: { align: "start" } },
        [
          _c("v-col", { staticClass: "d-flex flex-column align-left py-0" }, [
            _c("span", { staticClass: "text-fields" }, [
              _vm._v("Nome do ativo")
            ])
          ]),
          _c(
            "v-col",
            [
              _c("v-text-field", {
                staticClass: "select",
                attrs: {
                  loading: _vm.loading,
                  placeholder: "Insira o nome do ativo",
                  color: "secondary",
                  required: "",
                  outlined: "",
                  dense: "",
                  rounded: "",
                  height: "10",
                  rules: [
                    function(v) {
                      return !!v || "Campo obrigatório"
                    },
                    function(v) {
                      return (
                        (v && v.length > 3) ||
                        "O codigo deve conter de 4 a 19 caracteres."
                      )
                    },
                    function(v) {
                      return (
                        (v && v.length < 20) ||
                        "O codigo deve conter de 4 a 19 caracteres."
                      )
                    },
                    function(v) {
                      return (
                        !this$1.usersActive.some(function(a) {
                          return (
                            a.code &&
                            a.code.trim().toLowerCase() ===
                              (v || "").trim().toLowerCase()
                          )
                        }) || "Já existe um ativo com este nome."
                      )
                    }
                  ]
                },
                on: { keyup: _vm.saveCodigo },
                model: {
                  value: _vm.codigo,
                  callback: function($$v) {
                    _vm.codigo = $$v
                  },
                  expression: "codigo"
                }
              })
            ],
            1
          ),
          _c("v-col", { staticClass: "d-flex flex-column align-left py-0" }, [
            _c("span", { staticClass: "text-fields" }, [
              _vm._v("Descrição do ativo")
            ])
          ]),
          _c(
            "v-col",
            [
              _c("v-text-field", {
                staticClass: "select",
                attrs: {
                  loading: _vm.loading,
                  placeholder: "Insira a descrição do ativo",
                  color: "secondary",
                  required: "",
                  outlined: "",
                  dense: "",
                  rounded: "",
                  height: "10",
                  rules: [
                    function(v) {
                      return !!v || "Campo obrigatório"
                    },
                    function(v) {
                      return (
                        (v && v.length > 3) ||
                        "O codigo deve conter de 4 a 100 caracteres."
                      )
                    },
                    function(v) {
                      return (
                        (v && v.length < 101) ||
                        "O codigo deve conter de 4 a 100 caracteres."
                      )
                    }
                  ]
                },
                on: { keyup: _vm.saveDescription },
                model: {
                  value: _vm.description,
                  callback: function($$v) {
                    _vm.description = $$v
                  },
                  expression: "description"
                }
              })
            ],
            1
          ),
          _c("v-col", { staticClass: "d-flex flex-column align-left py-0" }, [
            _c("span", { staticClass: "text-fields" }, [_vm._v("Emissor")])
          ]),
          _c(
            "v-col",
            [
              _c("v-autocomplete", {
                staticClass: "select",
                attrs: {
                  items: _vm.entityCreditRisk,
                  loading: _vm.loading,
                  "item-text": "fullName",
                  "item-value": "entityId",
                  placeholder: "Insira o Emissor",
                  color: "secondary",
                  required: "",
                  outlined: "",
                  rounded: "",
                  dense: "",
                  clearable: "",
                  attach: "",
                  filter: _vm.filterObject,
                  rules: [
                    function(v) {
                      return v != null || "Campo obrigatório"
                    }
                  ]
                },
                on: { change: _vm.saveEmissor },
                model: {
                  value: _vm.emissor,
                  callback: function($$v) {
                    _vm.emissor = $$v
                  },
                  expression: "emissor"
                }
              })
            ],
            1
          ),
          _c("v-col", { staticClass: "d-flex flex-column align-left py-0" }, [
            _c("span", { staticClass: "text-fields" }, [_vm._v("Custodiante")])
          ]),
          _c(
            "v-col",
            [
              _c("v-autocomplete", {
                staticClass: "select",
                attrs: {
                  items: _vm.custodians,
                  loading: _vm.loading,
                  "item-text": "fullName",
                  "item-value": "entityId",
                  placeholder: "Insira o custodiante",
                  color: "secondary",
                  required: "",
                  outlined: "",
                  dense: "",
                  rounded: "",
                  height: "10",
                  clearable: "",
                  attach: "",
                  filter: _vm.filterObject,
                  rules: [
                    function(v) {
                      return v != null || "Campo obrigatório"
                    }
                  ]
                },
                on: { change: _vm.saveCustodiante },
                model: {
                  value: _vm.custodiante,
                  callback: function($$v) {
                    _vm.custodiante = $$v
                  },
                  expression: "custodiante"
                }
              })
            ],
            1
          ),
          _c("v-col", { staticClass: "d-flex flex-column align-left py-0" }, [
            _c("span", { staticClass: "text-fields" }, [_vm._v("Estratégia")])
          ]),
          _c(
            "v-col",
            [
              _c("v-autocomplete", {
                staticClass: "select",
                attrs: {
                  items: _vm.estrategias,
                  loading: _vm.loading,
                  "item-text": "descricao",
                  "item-value": "idEstrategia",
                  placeholder: "Insira a estratégia",
                  color: "secondary",
                  required: "",
                  outlined: "",
                  dense: "",
                  rounded: "",
                  height: "10",
                  "return-object": true,
                  clearable: "",
                  attach: "",
                  rules: [
                    function(v) {
                      return v != null || "Campo obrigatório"
                    }
                  ]
                },
                on: { change: _vm.saveEstrategia },
                model: {
                  value: _vm.estrategia,
                  callback: function($$v) {
                    _vm.estrategia = $$v
                  },
                  expression: "estrategia"
                }
              })
            ],
            1
          ),
          _c("v-row", { staticClass: "d-flex flex-wrap flexx" }, [
            _c(
              "div",
              { staticClass: "bloco" },
              [
                _c(
                  "v-col",
                  { staticClass: "d-flex flex-column align-left py-0" },
                  [
                    _c("span", { staticClass: "text-fields" }, [
                      _vm._v("Data Investimento")
                    ])
                  ]
                ),
                _c(
                  "v-col",
                  {
                    staticClass: "py-0 flex-grow-0 flex-shrink-1",
                    staticStyle: { padding: "0" }
                  },
                  [
                    _c("DatePiker", {
                      on: { change: _vm.saveDataInvestimento }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "bloco" },
              [
                _c(
                  "v-col",
                  { staticClass: "d-flex flex-column align-left py-0" },
                  [
                    _c("span", { staticClass: "text-fields" }, [
                      _vm._v("Valor Ação(R$)")
                    ])
                  ]
                ),
                _c(
                  "v-col",
                  { staticClass: "py-0", staticStyle: { padding: "0" } },
                  [
                    _c("ValorMonetario", {
                      attrs: { value: _vm.vPrecoUnitario },
                      on: { change: _vm.saveShareValue }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "bloco" },
              [
                _c(
                  "v-col",
                  { staticClass: "d-flex flex-column align-left py-0" },
                  [
                    _c("span", { staticClass: "text-fields" }, [
                      _vm._v("Nº de Ações")
                    ])
                  ]
                ),
                _c(
                  "v-col",
                  { staticClass: "py-0", staticStyle: { padding: "0" } },
                  [
                    _c("ValorMonetario", {
                      attrs: { value: _vm.vQtd },
                      on: { change: _vm.saveShareQuantity }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "bloco" },
              [
                _c(
                  "v-col",
                  { staticClass: "d-flex flex-column align-left py-0" },
                  [
                    _c("span", { staticClass: "text-fields" }, [
                      _vm._v("Total Investido(R$)")
                    ])
                  ]
                ),
                _c(
                  "v-col",
                  { staticClass: "py-0", staticStyle: { padding: "0" } },
                  [
                    _c("ValorMonetario", {
                      attrs: { value: _vm.vPrecoUnitarioQtd },
                      on: { change: _vm.saveInvestedValue }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }